import React, { Component } from 'react';
import { Translation } from 'react-i18next';
import { Affix, Card, Col, Input, Row, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import FormMetadata from '../../../elements/components/FormMetadata';

const DisplayInput = ({ label, value, ...props }) => (
  <div className='form-group'>
    <div className='ant-row ant-form-item' style={{ marginBottom: 0 }}>
      <div className='ant-col ant-col-5 ant-form-item-label'>
        <label
          htmlFor='cognito_form_answer_form_application'
          className=''
          title='Application'
        >
          {label}
        </label>
      </div>
      <div className='ant-col ant-col-19 ant-form-item-control'>
        <Input value={value} bordered={false} />
      </div>
    </div>
  </div>
);

class CognitoFormAnswerViewScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `CognitoFormAnswerViewScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    const { cognitoFormAnswer, isLoading, remove } = this.props;

    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('cognito_form_answers_route_view')} />

            <div className='cognito_form_answer-view'>
              <Row gutter={16}>
                <Col xs={24} lg={18}>
                  <Card
                    title={t('cognito_form_answers_view_title')}
                    extra={
                      isLoading ? (
                        <Spin
                          indicator={
                            <LoadingOutlined style={{ fontSize: 20 }} spin />
                          }
                        />
                      ) : null
                    }
                  >
                    <DisplayInput
                      label={t('cognito_form_answers_id')}
                      value={cognitoFormAnswer ? cognitoFormAnswer.id : null}
                    />
                    <DisplayInput
                      label={t('cognito_form_answers_form_id')}
                      value={
                        cognitoFormAnswer ? cognitoFormAnswer.form_id : null
                      }
                    />

                    <DisplayInput
                      label={t('cognito_form_answers_care_guide_first_name')}
                      value={
                        cognitoFormAnswer
                          ? cognitoFormAnswer.registration.care_guide_first_name
                          : null
                      }
                    />

                    <DisplayInput
                      label={t('cognito_form_answers_care_guide_last_name')}
                      value={
                        cognitoFormAnswer
                          ? cognitoFormAnswer.registration.care_guide_last_name
                          : null
                      }
                    />
                    <DisplayInput
                      label={t('cognito_form_answers_email')}
                      value={
                        cognitoFormAnswer
                          ? cognitoFormAnswer.registration.email
                          : null
                      }
                    />
                    <DisplayInput
                      label={t('cognito_form_answers_first_name')}
                      value={
                        cognitoFormAnswer
                          ? cognitoFormAnswer.registration.first_name
                          : null
                      }
                    />
                    <DisplayInput
                      label={t('cognito_form_answers_last_name')}
                      value={
                        cognitoFormAnswer
                          ? cognitoFormAnswer.registration.last_name
                          : null
                      }
                    />
                    <DisplayInput
                      label={t('cognito_form_answers_username')}
                      value={
                        cognitoFormAnswer
                          ? cognitoFormAnswer.registration.username
                          : null
                      }
                    />

                    {cognitoFormAnswer?.answers ? (
                      <>
                        {Object.entries(cognitoFormAnswer?.answers).map(
                          ([key, val]) => (
                            <DisplayInput
                              label={
                                Array.isArray(key.split(/(?=[A-Z])/))
                                  ? key.split(/(?=[A-Z])/).join(' ')
                                  : key.split(/(?=[A-Z])/)[0]
                              }
                              value={Array.isArray(val) ? val.join(', ') : val}
                            />
                          )
                        )}
                      </>
                    ) : null}
                  </Card>
                </Col>
                <Col xs={24} lg={6}>
                  <Affix offsetTop={10}>
                    <Card title={t('form_metadata_header')}>
                      <FormMetadata
                        id={cognitoFormAnswer?.id}
                        showStatus={false}
                        showSubmit={false}
                        isSubmitting={false}
                        delete={remove.bind(this)}
                        deleteRedirectTo='CognitoFormAnswersScreen'
                        createdAt={cognitoFormAnswer?.created_at}
                        updatedAt={cognitoFormAnswer?.updated_at}
                      />
                    </Card>
                  </Affix>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
    this.props.load(this.props.id);
  }
}

export default CognitoFormAnswerViewScreen;

Logger.log('silly', `CognitoFormAnswerViewScreen loaded.`);
